import { FC, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from '@platform/ui'
import { useAuth } from '@/features/auth/useAuth'
import { useSetActiveSlug } from '@/features/stencil/stubs'
import { useDocTitle } from '@/features/wa/title/useDocTitle'
import { PersonalInfo } from './components/PersonalInfo/PersonalInfo'
import { ProfileHeader } from './components/ProfileHeader/ProfileHeader'
import { TimezoneTab } from './components/TimezoneTab/TimezoneTab'
import { useSetProfileSidebar } from './hooks/useSetProfileSidebar'

import styles from './Profile.module.scss'

export enum TabName {
  PERSONAL_INFO = 'personalInfo',
  PREFERRED_TIME_ZONE = 'preferredTimeZone',
}

export const ProfilePage: FC = () => {
  useSetProfileSidebar()
  useSetActiveSlug('profile')
  useDocTitle('userProfile.heading')

  const { user } = useAuth()
  const [activeKey, setActiveKey] = useState(TabName.PERSONAL_INFO)

  const { t } = useTranslation()

  const handleTabTitleClick = useCallback((key: string) => {
    setActiveKey(key as TabName)
  }, [])

  if (!user) return null

  return (
    <div className={styles.profilePageContainer}>
      <ProfileHeader />

      <Tabs activeKey={activeKey} withSeparator onChange={handleTabTitleClick}>
        <Tabs.TabPane tab={t('userProfile.personalInfo')} key={TabName.PERSONAL_INFO}>
          <PersonalInfo />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t('userProfile.preferredTimeZone')} key={TabName.PREFERRED_TIME_ZONE}>
          <TimezoneTab />
        </Tabs.TabPane>
      </Tabs>
    </div>
  )
}
